/* unplugin-vue-components disabled */import script from "./App.vue.ts?vue&type=script&lang=ts&setup=true!=!../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./App.vue?vue&type=script&lang=ts&setup=true"
export * from "./App.vue.ts?vue&type=script&lang=ts&setup=true!=!../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./App.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__